import api from "./api";

const createTechnician = (data) => {
  return api.post("/api/technician/create", data);
};

const updateBulkTechnician = (data) => {
  return api.post("/api/technician/update_bulk_technician", data);
};

const deleteTechnician = (data) => {
  return api.post("/api/technician/delete", data);
};

const update = data => {
  return api.post('/api/technician/update', data);
};

const getTimesheetByWoId = (woId) => {
  return api.get('/api/technician/get_timesheet_by_wo_id', { params: { woId } });
};

const getStatusBoard = (branch) => {
  return api.get('/api/technician/get_status_board', { params: { branch } });
};

const TechnicianService = {
  update,
  createTechnician,
  updateBulkTechnician,
  deleteTechnician,
  getTimesheetByWoId,
  getStatusBoard,
};

export default TechnicianService;
